var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.87 64.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.02,
    cy: 34.74,
    rx: 10.02,
    ry: 13.87,
    fill: "#ccdff8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.87,47.72c-8.38,0-15.88,2.01-20.87,5.17,4.66,6.59,12.34,10.89,21.02,10.89s16.25-4.24,20.92-10.75c-4.98-3.24-12.57-5.31-21.08-5.31Z",
    fill: "#ccdff8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.67,
    y: 38.03,
    width: 10.7,
    height: 16.35,
    rx: 5.35,
    ry: 5.35,
    fill: "#ccdff8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.59,35.53c.3,2.22-.19,4.15-1.1,4.31-.91,.15-1.89-1.52-2.19-3.75-.3-2.22,.19-4.15,1.1-4.31,.91-.15,1.89,1.52,2.19,3.75Z",
    fill: "#ccdff8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.46,35.53c-.3,2.22,.19,4.15,1.1,4.31,.91,.15,1.89-1.52,2.19-3.75,.3-2.22-.19-4.15-1.1-4.31-.91-.15-1.89,1.52-2.19,3.75Z",
    fill: "#ccdff8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.36,34.19c-.34-2.22-.67-4.44-1.01-6.66-.12-.81-.24-1.66,.05-2.42,.29-.76,1.16-1.37,1.92-1.08-.31-1.54,1.4-2.69,2.89-3.2,2.5-.86,5.17-1.3,7.79-.96,2.62,.34,5.17,1.5,6.94,3.46,.56,.62,1.04,1.33,1.31,2.12,.51,1.52,.19,3.19-.14,4.76-.26,1.25-.52,2.5-.79,3.75-.06,.29-.13,.59-.32,.8-.31,.35-.83,.37-1.3,.37-4.97,.01-9.93,.02-14.9,.03-.93,0-2.15-.23-2.28-1.15",
    fill: "#ccdff8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.95,
    cy: 34.74,
    rx: 10.02,
    ry: 13.87,
    fill: "#ccdff8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.79,47.72c-8.38,0-15.88,2.01-20.87,5.17,4.66,6.59,12.34,10.89,21.02,10.89s16.25-4.24,20.92-10.75c-4.98-3.24-12.57-5.31-21.08-5.31Z",
    fill: "#ccdff8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.59,
    y: 38.03,
    width: 10.7,
    height: 16.35,
    rx: 5.35,
    ry: 5.35,
    fill: "#ccdff8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.51,35.53c.3,2.22-.19,4.15-1.1,4.31-.91,.15-1.89-1.52-2.19-3.75-.3-2.22,.19-4.15,1.1-4.31,.91-.15,1.89,1.52,2.19,3.75Z",
    fill: "#ccdff8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.38,35.53c-.3,2.22,.19,4.15,1.1,4.31,.91,.15,1.89-1.52,2.19-3.75,.3-2.22-.19-4.15-1.1-4.31-.91-.15-1.89,1.52-2.19,3.75Z",
    fill: "#ccdff8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.28,34.19c-.34-2.22-.67-4.44-1.01-6.66-.12-.81-.24-1.66,.05-2.42,.29-.76,1.16-1.37,1.92-1.08-.31-1.54,1.4-2.69,2.89-3.2,2.5-.86,5.17-1.3,7.79-.96,2.62,.34,5.17,1.5,6.94,3.46,.56,.62,1.04,1.33,1.31,2.12,.51,1.52,.19,3.19-.14,4.76-.26,1.25-.52,2.5-.79,3.75-.06,.29-.13,.59-.32,.8-.31,.35-.83,.37-1.3,.37-4.97,.01-9.93,.02-14.9,.03-.93,0-2.15-.23-2.28-1.15",
    fill: "#ccdff8"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.01,
    cy: 21.83,
    rx: 14.6,
    ry: 20.22,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.78,40.75c-12.22,0-23.14,2.93-30.41,7.53,6.8,9.6,17.98,15.87,30.64,15.87s23.68-6.18,30.49-15.67c-7.26-4.72-18.33-7.73-30.72-7.73Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.21,
    y: 26.63,
    width: 15.6,
    height: 23.83,
    rx: 6.93,
    ry: 6.93,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.71,22.98c.44,3.24-.28,6.05-1.61,6.28-1.32,.23-2.75-2.22-3.19-5.46-.44-3.24,.28-6.05,1.61-6.28,1.32-.23,2.75,2.22,3.19,5.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3,22.98c-.44,3.24,.28,6.05,1.61,6.28,1.32,.23,2.75-2.22,3.19-5.46,.44-3.24-.28-6.05-1.61-6.28s-2.75,2.22-3.19,5.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.92,21.03c-.49-3.24-.98-6.47-1.47-9.71-.18-1.18-.35-2.41,.08-3.52,.43-1.11,1.69-1.99,2.8-1.57-.45-2.25,2.05-3.91,4.22-4.66,3.64-1.25,7.54-1.89,11.35-1.4,3.81,.49,7.54,2.18,10.11,5.04,.81,.91,1.52,1.93,1.9,3.09,.75,2.22,.27,4.64-.21,6.94-.38,1.82-.76,3.64-1.15,5.47-.09,.42-.18,.85-.47,1.17-.45,.5-1.22,.54-1.89,.54-7.24,.02-14.48,.03-21.72,.05-1.36,0-3.14-.33-3.32-1.68",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessWhite);
export default __webpack_public_path__ + "static/media/BusinessWhite.c3129fca02ee02032f521b224d39f16d.svg";
export { ForwardRef as ReactComponent };